export default __webpack_public_path__ + "static/media/a6.f3b7e554.png";